var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 11.5945C9.2765 11.5945 8.7245 7.46653 8.7245 7.46653C8.4005 5.31853 9.3845 2.89453 11.9645 2.89453C14.5565 2.89453 15.5405 5.31853 15.2165 7.46653C15.2165 7.46653 14.7245 11.5945 12.0005 11.5945ZM12.0005 14.6785L15.2645 12.4945C18.1325 12.4945 20.6885 15.2905 20.6885 17.9305V20.9185C20.6885 20.9185 16.3085 22.2745 12.0005 22.2745C7.6205 22.2745 3.3125 20.9185 3.3125 20.9185V17.9305C3.3125 15.2305 5.6405 12.5545 8.6765 12.5545L12.0005 14.6785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.9f7f78ed63c5155bb16bf607c02fca02.svg";
export { ForwardRef as ReactComponent };